<template>
	<div
		id="panel-tinkoff"
		class="panel"
		:class="[
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div
			class="container"
			:class="[
				isBrand? 'sk' : '',
			]"
		>
			<div class="row border-line mb-4">
				<div class="col-12 col-lg-6">
					<div class="column-between">
						<div class="row justify-content-start mb-3">
							<div class="col-12 col-sm-12 col-md-6 col-lg-6">
								<img
									class="partnerlogo mb-3 mb-md-0"
									src="/svg/logo-black.svg"
									alt="SBP logo"
								>
							</div>
						</div>
						<div class="title">
							Система быстрых платежей (СБП)
						</div>
						<div class="description">
							Выберите способ оплаты через СБП, на экране оплаты нажмите на кнопку или отсканируйте QR-код, перейдите в приложение вашего банка и подтвердите оплату. Покупка готова!
						</div>
						<div v-if="showRegistration" class="bottom-control mt-4 row">
							<div class="col-auto">
								<a
									v-scroll-to="registrationForm"
									href="#"
									class="btn btn-primary"
								>
									{{ $t('register') }}
								</a>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="column-between mt-4 mt-lg-0">
						<div class="row justify-content-start mb-3">
							<div class="col-12 col-sm-12 col-md-6 col-lg-6">
								<img
									class="partnerlogo mb-3 mb-md-0"
									src="/svg/ece38c8f-4d3b-4b22-a7ee-05449e43c2c5.svg"
									alt="Tinkoff logo"
								>
							</div>
						</div>
						<div class="title">
							Не всё сразу: платите в рассрочку вместе с Тинькофф
						</div>
						<div class="description">
							После прохождения всех этапов регистрации выберите «Покупка в рассрочку» и вносите оплату частями
						</div>
						<div class="bottom-control mt-4 row">
							<div class="col-auto">
								<a href="/tinkoff-credit/" class="btn btn-outline-primary">{{ $t('more') }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import panel from '~/mixins/panel';

export default {
	name: 'PanelTinkoffCredit',
	mixins: [panel],
	data() {
		return {
			showRegistration: false,
		};
	},
	computed: {
		registrationForm() {
			const checkoutForm = document.getElementById('checkout-form');
			return checkoutForm ? '#checkout-form' : '#empty-registration';
		},
	},
	mounted() {
		this.showRegistration = true;
	},
};
</script>

<style lang="scss" scoped>
@import '/assets/styles/components/home/panel-tinkoff';
</style>
